export const IconSizes = {
  small: 16,
  medium: 20,
  large: 24,
  extraLarge: 48,
};

export const ImageSizes = {
  small: 20,
  medium: 40,
  large: 60,
};
